export default __webpack_public_path__ + "static/media/128.b35f3018.webp";